import { type Actions, ActionType } from './usages.actions';
import { initialState, type State, usagesAdapter } from './usages.state';

export function usagesReducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionType.FETCH_USAGES_SUCCEEDED:
            return usagesAdapter.setAll(action.payload.usages, { ...state, isLoaded: true, isPending: false });

        case ActionType.FETCH_USAGES_FAILED:
            return { ...state, isLoaded: false, isPending: false };

        case ActionType.FETCH_USAGES:
            return { ...state, isPending: true };

        case ActionType.RESET:
            return { ...initialState };

        default:
            return state;
    }
}
